import { NewConnectionFormValues } from "../../../../types/NewConnectionFormValues";

export const shouldGoToReview = (values: NewConnectionFormValues) => {
  return values.filesUploadStatus === "DONE";
};
